import urlParser from 'root/src/shared/util/urlParser';
import { Platform } from 'root/src/shared/@types/platforms';
import { stringify } from 'qs';
import outputs from 'root/cfOutput';
import { LanguageService } from 'root/src/client/v2/common/helpers/language.service';
import { isLocalhost } from 'root/src/shared/util/envSelect';
const { domainName } = outputs;
export const getEmbedUrl = (url, { muted, autoplay, start } = {}) => {
    const parsedUrl = urlParser(url);
    if (!parsedUrl)
        return '';
    const languageCode = LanguageService.getDomainPrefixCode(window.location.host);
    const queryBase = {
        autoplay: true,
        parent: isLocalhost ? 'localhost' : languageCode ? `${languageCode}.${domainName}` : domainName,
    };
    const twitchQueryBase = {
        muted,
        autoplay,
    };
    // Only attach a positive start offset; 0 / undefined are skipped so callers that pass no start
    // (every existing one) keep their current embed URL.
    const startSeconds = typeof start === 'number' && start > 0 ? start : undefined;
    const { id, provider, mediaType } = parsedUrl;
    if (provider === Platform.Twitch && mediaType === 'clip') {
        const query = stringify(Object.assign(Object.assign(Object.assign({}, queryBase), twitchQueryBase), { clip: id }));
        return `https://clips.twitch.tv/embed?${query}`;
    }
    if (provider === Platform.Twitch && mediaType === 'video') {
        const query = stringify(Object.assign(Object.assign(Object.assign({}, queryBase), twitchQueryBase), { video: `v${id}`, time: startSeconds ? `${startSeconds}s` : undefined }));
        return `https://player.twitch.tv?${query}`;
    }
    if (provider === Platform.YouTube
        && (mediaType === 'video' || mediaType === 'shorts')) {
        const query = stringify(Object.assign(Object.assign({}, queryBase), { autoplay: 1, 
            // there has to be mute, otherwise autoplay doesn't works
            mute: 1, start: startSeconds }));
        return `https://www.youtube.com/embed/${id}?${query}`;
    }
    if (provider === Platform.TikTok && (mediaType === 'video')) {
        const query = stringify(Object.assign({}, queryBase));
        return `https://www.tiktok.com/player/v1/${id}?${query}`;
    }
    // urlParser returns the facebook provider as the raw string 'facebook' (it is not in the
    // Platform enum). Facebook's iframe video plugin embeds by the original URL, so no id is needed.
    if (provider === 'facebook') {
        const query = stringify({
            href: url,
            show_text: false,
            autoplay,
        });
        return `https://www.facebook.com/plugins/video.php?${query}`;
    }
    return '';
};
